import React, { FunctionComponent } from "react";
import styled from "styled-components";

const StyledPre = styled.pre`
`;

export const Pre: FunctionComponent = (props) =>{
  return(
    <StyledPre>
      {props.children}
    </StyledPre>
  )
}